import React from "react";
import { useDropzone } from "react-dropzone";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import csvtojson from "csvtojson";

const CSVUploadDropZone = ({ onFileUpload, text }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: async (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file && file.type === "text/csv") {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const csvString = e.target.result;
          const jsonArray = await csvtojson().fromString(csvString);
          if (jsonArray.length) {
            onFileUpload(jsonArray);
          } else {
            alert("File is empty.");
          }
        };
        reader.readAsText(file);
      } else {
        alert("Kindly upload csv file.");
      }
    },
    maxFiles: 1,
    multiple: false,
    accept: ".csv",
  });

  return (
    <>
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        <FileUploadOutlinedIcon />
        <p>{text}</p>
      </div>
    </>
  );
};

export default CSVUploadDropZone;
